import DownloadIcon from "~icons/local/download-bordered";

export default function Download({ fileUrl }: { fileUrl: string }) {
  return (
    <a href={fileUrl} download>
      <DownloadIcon className="cursor-pointer" />
    </a>
  );
}
